"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../schema");
const sex_1 = require("../../concepts/sex");
const location_1 = require("../../concepts/location");
const socialSecurityNumber = schema_1.Schema.socialSecurityNumber().interpretation({
    vocab: "snomed",
    code: "398093005"
});
const patientHospitalNumber = schema_1.Schema.string()
    .optional()
    .interpretation({ vocab: "snomed", code: "184107009" });
const dateOfBirth = schema_1.Schema.date().interpretation({
    vocab: "snomed",
    code: "184099003"
});
const countryOfBirth = location_1.country.interpretation({
    vocab: "snomed",
    code: "315354004"
});
const placeOfBirthInterpretation = { vocab: "snomed", code: "169812000" };
const placeOfBirth = schema_1.Schema.ifThenElse(schema_1.Schema.expression(`{../countryOfBirth} === "${location_1.hunCountryCode}"`), location_1.hunPlace.interpretation(placeOfBirthInterpretation), location_1.place.interpretation(placeOfBirthInterpretation));
const title = schema_1.Schema.string()
    .optional()
    .interpretation({ vocab: "snomed", code: "184098006" });
const firstName = schema_1.Schema.string().interpretation({
    vocab: "snomed",
    code: "184095009"
});
const lastName = schema_1.Schema.string().interpretation({
    vocab: "snomed",
    code: "184096005"
});
const maidenName = schema_1.Schema.string().interpretation({
    vocab: "snomed",
    code: "423203003"
});
const maidenNameOfMother = schema_1.Schema.string().interpretation({
    vocab: "snomed",
    code: "423775007"
});
const phoneNumberList = schema_1.Schema.array()
    .items(schema_1.Schema.phoneNumber())
    .minItems(1)
    .default([undefined]);
const patientPhoneNumberList = phoneNumberList.interpretation({
    vocab: "snomed",
    code: "734005006"
});
const emailList = schema_1.Schema.array().items(schema_1.Schema.email()).optional().default([]);
const patientAddress = schema_1.Schema.object()
    .properties({
    country: location_1.country,
    county: schema_1.Schema.ifThenElse(schema_1.Schema.expression(`{../country} === "${location_1.hunCountryCode}"`), location_1.hunCounty.optional(), location_1.county.optional()),
    postCode: schema_1.Schema.ifThenElse(schema_1.Schema.expression(`{../country} === "${location_1.hunCountryCode}"`), location_1.hunPostCode, location_1.postCode),
    city: schema_1.Schema.ifThenElse(schema_1.Schema.expression(`{../country} === "${location_1.hunCountryCode}"`), location_1.hunPlace, location_1.place),
    addressLineOne: schema_1.Schema.string(),
    addressLineTwo: schema_1.Schema.string().optional()
})
    .sealed()
    .default({})
    .interpretation({ vocab: "snomed", code: "184097001" })
    .tag({ vocab: "loinc", code: "56799-0" });
const generalPractitioner = schema_1.Schema.object()
    .properties({
    title: schema_1.Schema.string().optional(),
    firstName: schema_1.Schema.string(),
    lastName: schema_1.Schema.string(),
    phoneNumbers: phoneNumberList,
    emails: emailList,
    stampNumber: schema_1.Schema.stampNumber(),
    medicalPractitionerHospitalNumber: schema_1.Schema.string().optional()
})
    .sealed()
    .default({})
    .interpretation({
    vocab: "fyrms",
    code: "general_practitioner_of_the_patient"
});
const connectedUsers = schema_1.Schema.array()
    .items(schema_1.Schema.remoteSelect("$users"))
    .optional()
    .default([]);
exports.validator = schema_1.Schema.form()
    .properties({
    socialSecurityNumber,
    patientHospitalNumber,
    dateOfBirth,
    countryOfBirth,
    placeOfBirth,
    sex: sex_1.sex,
    title,
    firstName,
    lastName,
    maidenName,
    maidenNameOfMother,
    phoneNumbers: patientPhoneNumberList,
    emails: emailList,
    address: patientAddress,
    hasGeneralPractitioner: schema_1.Schema.boolean().default(false),
    generalPractitioner: schema_1.Schema.ifThen(schema_1.Schema.expression("{../hasGeneralPractitioner} === true"), generalPractitioner),
    connectedUsers
})
    .tag({ vocab: "snomed", code: "302147001" })
    .tag({ vocab: "loinc", code: "55174-7" });
